import { useState } from "react";
import { fmt, fmtDate } from "@/lib/format";

const trLower = (s) => String(s ?? "").toLocaleLowerCase("tr");

function dparse(s) {
  const m = String(s || "").match(/(\d{2})\.(\d{2})\.(\d{4})/);
  if (m) return new Date(+m[3], +m[2] - 1, +m[1]).getTime();
  const t = new Date(s).getTime();
  return isNaN(t) ? 0 : t;
}

export function colDisp(c, r) {
  if (c.accessor) return c.accessor(r);
  if (c.type === "money") return fmt(r[c.key]);
  if (c.type === "date") return fmtDate(r[c.key]);
  return String(r[c.key] ?? "");
}

// Excel benzeri sütun filtresi + sıralama (client-side) — tüm tablolarda ortak.
export function useColFilter(cols, rows) {
  const [colSel, setColSel] = useState({});
  const [sort, setSort] = useState({ key: null, dir: null });

  const distinct = (c) => {
    const arr = [...new Set(rows.map((r) => colDisp(c, r)))];
    if (c.type === "money") arr.sort((a, b) => (parseFloat(String(a).replace(/[^\d,-]/g, "").replace(",", ".")) || 0) - (parseFloat(String(b).replace(/[^\d,-]/g, "").replace(",", ".")) || 0));
    else if (c.type === "date") arr.sort((a, b) => dparse(a) - dparse(b));
    else arr.sort((a, b) => trLower(a).localeCompare(trLower(b), "tr"));
    return arr;
  };

  const filtered = rows.filter((r) => cols.every((c) => { const sel = colSel[c.key]; return !sel || sel.includes(colDisp(c, r)); }));

  let view = filtered;
  if (sort.key) {
    const col = cols.find((c) => c.key === sort.key);
    view = [...filtered].sort((a, b) => {
      let av, bv;
      if (col.type === "money") { av = Number(a[col.key]) || 0; bv = Number(b[col.key]) || 0; }
      else if (col.type === "date") { av = dparse(colDisp(col, a)); bv = dparse(colDisp(col, b)); }
      else { av = trLower(colDisp(col, a)); bv = trLower(colDisp(col, b)); }
      return av < bv ? (sort.dir === "asc" ? -1 : 1) : av > bv ? (sort.dir === "asc" ? 1 : -1) : 0;
    });
  }

  return { colSel, setColSel, sort, setSort, view, distinct };
}
